module.exports = __webpack_public_path__ + "static/img/gpt34.1b4028b4.png";